export default {
  workProcessContent: {
    subtitle: "HOW IT WORKS",

    title1: "Simple & Transparent",
    title2: "Procurement Process",

    step1_title: "Browse & Select",
    step1_desc:
      "Choose products from verified suppliers with transparent pricing.",

    step2_title: "Add to Cart",
    step2_desc:
      "Manage quantities, schedules, and recurring orders with ease.",

    step3_title: "Secure Payment",
    step3_desc:
      "Pay securely with clear invoices and business-friendly billing.",

    step4_title: "Reliable Delivery",
    step4_desc:
      "Receive fresh supplies on time through our delivery network.",
  },
};